import React from 'react';
import axios from 'axios';
import { Col, Row, Button,Glyphicon } from 'react-bootstrap';
import Error from './Error';
import { clearUser } from '../../utils/FRLogout';

class Unauthorized extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            portalUrl: ''
        };
    }

   
    handleLogout = () => {
            clearUser();
    }

    renderError = () => {
        if (this.props.location.query && this.props.location.query.logout) {
            return null;
        }
        else {
            return <Error errorType={'auth'} />
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.renderError()}
                <Row>
                    <Col xs={10} xsOffset={1}>
                        <div style={{ textAlign: 'center', paddingTop: `${this.props.location.query &&
                            this.props.location.query.logout ? '20%' : '7%'}`, paddingBottom: '10%' }}>
                            {localStorage.getItem("insufficientRole") &&(
                                <>
                                <p style={{ display: 'inline', fontSize: '16px', marginLeft: '1rem' }}>You do not have the required permissions to view this page. Please contact your administrator for assistance.</p>
                                <br/><br/>
                                </>
                            )}
                            <Button onClick={() => this.handleLogout()} style={{ color: 'inherit' }}><Glyphicon glyph="log-out" style={{ marginRight: '0.2rem' }} />Logout</Button>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default Unauthorized;